import RefreshImg from "public/migrationToMost/wpf_refresh-shield.svg";
import PeopleImg from "public/migrationToMost/fluent_people-team-20-filled.svg";
import serverImg from "public/migrationToMost/fa6-solid_server.svg";
import IntegrationImg from "public/migrationToMost/oui_integration-general.svg";

export const WHY_ENTERPRISES_MIGRATE_CONSTANTS = [
  {
    image: IntegrationImg,
    title: "Full API Access",
    text: "No black-box configurations, total stack visibility.",
  },
  {
    image: PeopleImg,
    title: "Built-in Monitoring",
    text: "Native support for Grafana and Elastic for complete operational insight.",
  },
  {
    image: serverImg,
    title: "Predictable Pricing",
    text: "Flat-rate or usage-based billing with no hidden fees.",
  },
  {
    image: RefreshImg,
    title: "Enterprise-Grade Security",
    text: "Isolated tenants, RBAC, and encrypted volumes to protect your data.",
  },
  {
    image: RefreshImg,
    title: "Hybrid-Ready",
    text: "Interconnect MOST with your existing environments via SD-WAN or VPN.",
  },
];
